class IngredientsAccordion extends HTMLElement {
    constructor() {
        super();
        this.accordions = Array.from(this.querySelectorAll('ingredient-accordion'));
        this.images = Array.from(this.querySelectorAll('ingredient-media'));
        this.tabHeaders = Array.from(this.querySelectorAll('tab-header'));
        this.tabContents = Array.from(this.querySelectorAll('tab-content'));

        this.accordions.forEach((accordion, index) => {
            accordion.addEventListener('click', () => this.openAccordion(index));
        });

        this.tabHeaders.forEach((tabHeader, index) => {
            tabHeader.addEventListener('click', () => this.openTab(index));
        });

    }

    openAccordion(activeIndex) {
        this.accordions.forEach((accordion, i) => {
            const details = accordion.querySelector('details');
            console.log(details, activeIndex, "click")
            if (!details) return;
            setTimeout(() => {
                details.open =  true;
            }, 0);
        });
        
        // Get current active image's media ID
        const currentActive = this.images.find(img => img.classList.contains('active'));
        const currentMediaId = currentActive?.getAttribute('data-media-id');
        const newMediaId = this.images[activeIndex]?.getAttribute('data-media-id');
        
        // Check if it's the same image
        const isSameImage = currentMediaId && newMediaId && currentMediaId === newMediaId;
        
        // Temporarily disable transition if same image
        if (isSameImage) {
            this.images.forEach((img) => {
                img.style.transition = 'none';
            });
        }
        
        this.images.forEach((img, i) => {
            img.classList.toggle('active', i === activeIndex);
        });
        
        // Re-enable transition after a brief moment
        if (isSameImage) {
            requestAnimationFrame(() => {
                this.images.forEach((img) => {
                    img.style.transition = '';
                });
            });
        }
    }
    
    openTab(activeIndex) {
        this.tabHeaders.forEach((tabHeader, i)=>{
            tabHeader.classList.toggle('active', i === activeIndex );
        })

        this.tabContents.forEach((tabContent, i)=>{
            tabContent.classList.toggle('active', i === activeIndex );
        })

        // Get current active image's media ID
        const currentActive = this.images.find(img => img.classList.contains('active'));
        const currentMediaId = currentActive?.getAttribute('data-media-id');
        const newMediaId = this.images[activeIndex]?.getAttribute('data-media-id');
        
        // Check if it's the same image
        const isSameImage = currentMediaId && newMediaId && currentMediaId === newMediaId;
        
        // Temporarily disable transition if same image
        if (isSameImage) {
            this.images.forEach((img) => {
                img.style.transition = 'none';
            });
        }

        this.images.forEach((img, i) => {
            img.classList.toggle('active', i === activeIndex);
        });
        
        // Re-enable transition after a brief moment
        if (isSameImage) {
            requestAnimationFrame(() => {
                this.images.forEach((img) => {
                    img.style.transition = '';
                });
            });
        }
    }
}

if (!customElements.get('ingredients-accordion')) {
    customElements.define('ingredients-accordion', IngredientsAccordion);
}
